import { ITimeSource, TimeListener } from '@fe/core';

export abstract class BaseTimeSource implements ITimeSource {
    abstract get currentTime(): number;
    abstract get currentTimeMs(): number;

    private listeners: TimeListener[] = [];

    protected fire(time: number, sourceChanged?: boolean) {
        for (const listener of this.listeners) {
            listener(time, sourceChanged ?? false);
        }
    }

    on(listener: TimeListener) {
        if (!this.listeners.includes(listener)) {
            this.listeners.push(listener);
        }
        return () => this.off(listener);
    }

    off(listener: TimeListener) {
        const idx = this.listeners.indexOf(listener);
        if (idx > -1) {
            this.listeners.splice(idx, 1);
        }
    }
}
